import type { Friend, UserProfile } from '@/types'

type WithNickname = UserProfile & { nickname?: string | null }

export function hueFromId(id: string): number {
  let hash = 0
  for (const c of id) hash = (hash * 31 + c.charCodeAt(0)) | 0
  return Math.abs(hash) % 360
}

const STEAM_IMG = 'https://cdn.akamai.steamstatic.com/steam/apps'

export function steamGameImageUrl(appId: number, variant: 'capsule_sm' | 'capsule' | 'header' | 'portrait'): string {
  const file = {
    capsule_sm: 'header.jpg',
    capsule:    'header.jpg',
    header:     'header.jpg',
    portrait:   'library_600x900.jpg',
  }[variant]
  return `${STEAM_IMG}/${appId}/${file}`
}

export function toFriend(p: WithNickname): Friend {
  return {
    id: p.steamId,
    name: p.name,
    handle: p.handle,
    status: p.status as Friend['status'],
    hue: hueFromId(p.steamId),
    level: '?',
    avatarUrl: p.avatarUrl,
    nickname: p.nickname ?? null,
  }
}
